import React, { useState, useEffect, forwardRef } from 'react';
import InputMask from 'react-input-mask';
import { Input } from 'reactstrap';
import { cpf as cpfValidator } from 'cpf-cnpj-validator';

const CPF = forwardRef((props, ref) => {
    const [value, updateValue] = useState(props.value ? props.value : '');
    let className = '';

    const handleChange = (element, field) => {
        let elementValue = element.target.value;
        if (elementValue.length === 14 && !cpfValidator.isValid(elementValue)) {
            elementValue = '';
        } 
        props.onChange(element, field);
        updateValue(elementValue);        
    };


    if (props.error) {
        className = "is-invalid";
    }
    return (
        <div ref={ref}>
            <Input
                type="text"
                mask="999.999.999-99"
                maskChar=""
                tag={InputMask}
                className={className}
                id={'id_' + props.name}
                name={props.name}
                onChange={(element, field) => handleChange(element, field)}
                value={value}
                readOnly={props.readOnly}
                autoFocus={props.autoFocus || false}
            />
            {props.error && (
                <span id="terms-error" className="error invalid-feedback" style={{ display: 'inline' }}>{props.error}</span>
            )}
        </div>
    );
});

export default CPF;
